import React, { useEffect, useState } from 'react';

// Icons by name, loaded lazily so the full lucide-react set stays out of the entry bundle.
// 1) appIconRegistry.generated.js holds every icon name used as a string in src/ (small chunk).
// 2) A name missing from it loads the full lucide-react module once, so nothing breaks.
// Regenerate the registry with: node scripts/gen-app-icon-registry.mjs
let registry = null;
let registryPromise = null;
let fullSet = null;
let fullPromise = null;

function loadRegistry() {
  if (!registryPromise) {
    registryPromise = import('./appIconRegistry.generated.js').then((m) => { registry = m.default; return registry; });
  }
  return registryPromise;
}
function loadFull() {
  if (!fullPromise) {
    fullPromise = import('lucide-react').then((m) => { fullSet = m; return m; });
  }
  return fullPromise;
}

export function resolveIcon(name) {
  if (!name) return null;
  return registry?.[name] || fullSet?.[name] || null;
}

/** Warm the icon registry early (optional). */
export function preloadIcons() { return loadRegistry(); }

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const [, bump] = useState(0);
    const IconComponent = resolveIcon(name);
    const pending = !IconComponent && (!registry || (!fullSet && name));

    useEffect(() => {
        if (IconComponent) return undefined;
        let alive = true;
        const done = () => { if (alive) bump((n) => n + 1); };
        if (!registry) loadRegistry().then(done, done);
        else if (!fullSet && name) loadFull().then(done, done);
        return () => { alive = false; };
    }, [name, IconComponent]);

    if (IconComponent) {
        return <IconComponent size={size} color={color} strokeWidth={strokeWidth} className={className} {...props} />;
    }
    if (pending) {
        // Same footprint as the icon so layout does not shift while it loads.
        return <span aria-hidden="true" className={className} style={{ display: 'inline-block', width: size, height: size, flexShrink: 0 }} />;
    }
    const Fallback = registry?.HelpCircle;
    return Fallback
        ? <Fallback size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />
        : null;
}
export default Icon;
